module.exports = __webpack_public_path__ + "img/smxzapp2023.c4170337.png";